<script setup>
import { computed } from 'vue'
import { useLocaleStore } from '@/stores/localeStore'
import activitiesData from '@/data/activities-data.json'
import NextButton from '../NextButton.vue'
import PreviousButton from '../PreviousButton.vue'

defineEmits(['open-window', 'minimize-window'])

const localeStore = useLocaleStore()
const currentLocale = computed(() => localeStore.currentLocale)

const activities = computed(() => {
  return activitiesData[currentLocale.value]?.activities || []
})

const activitiesDataComputed = computed(() => {
  return activitiesData[currentLocale.value] || {}
})
</script>

<template>
  <div class="relative right-0 h-content-window overflow-hidden">
    <div class="w-full h-full bg-white overflow-auto p-2 pb-28">
      <div>
        <section class="mt-2">
          <h2 class="font-trebuchet-pixel underline text-base mb-3">{{ $t('windows.activites.title') }}</h2>
          <p class="text-xs mb-4 text-gray-700 leading-relaxed">{{ $t('windows.activites.description') }}</p>

          <!-- Paragraphe récapitulatif avec mention du SNEE -->
          <div v-if="activitiesDataComputed.introduction" class="mb-6 p-4 bg-blue-50 border-l-4 border-blue-500 rounded">
            <p class="text-xs text-gray-800 leading-relaxed">{{ activitiesDataComputed.introduction }}</p>
          </div>

          <!-- Certificat SNEE -->
          <div class="mb-6">
            <div class="flex justify-center">
              <img 
                src="/img/certificates/certificat-snee.webp" 
                alt="Certificat SNEE" 
                class="max-w-full h-auto rounded shadow-md"
              />
            </div>
          </div>

          <div class="space-y-4">
            <div v-for="activity in activities" :key="activity.id" class="border border-gray-300 p-4 rounded">
              <div class="flex items-start justify-between mb-2">
                <div>
                  <h3 class="font-trebuchet-pixel font-semibold text-sm">{{ activity.title }}</h3>
                  <div class="flex items-center gap-2 mt-1">
                    <span class="text-xxs bg-blue-100 px-2 py-0.5 rounded">{{ activity.type }}</span>
                    <span class="text-xxs text-gray-600">{{ activity.period }}</span>
                  </div>
                </div>
              </div>
              <p class="text-xs text-gray-700 mb-3 mt-2">{{ activity.description }}</p>

              <div v-if="activity.achievements && activity.achievements.length > 0">
                <h4 class="font-trebuchet-pixel text-xs font-semibold mb-1">{{ $t('windows.activites.achievements') }}:</h4>
                <ul class="list-disc list-inside text-xxs ml-2 space-y-1 text-gray-700">
                  <li v-for="achievement in activity.achievements" :key="achievement">{{ achievement }}</li>
                </ul>
              </div>

              <div v-if="activity.link" class="mt-2">
                <a :href="activity.link" class="text-xxs text-blue-600 underline">{{ $t('windows.activites.viewMore') }}</a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <PreviousButton current-window-id="activites" @open-window="$emit('open-window', $event)" @minimize-window="$emit('minimize-window', $event)" />
      <NextButton current-window-id="activites" @open-window="$emit('open-window', $event)" @minimize-window="$emit('minimize-window', $event)" />
    </div>
  </div>
</template>
